import React from "react";
import "./Speakhabla.css";
import rebranding from "../../assets/rebranding.png";
import sofia from "../../assets/sofia.png";
import personas from "../../assets/personas.png";
import infoarchitecture from "../../assets/infoarchitecture.png";
import speak from "../../assets/speak.png";
import dashboard from "../../assets/dashboards.png";
import techStack from "../../assets/techStack.png";

const Speakhabla = () => {
  return (
    <>
      <div className="habla-section ">
        <div className="habla-about">
          <h3>
            <span>speakhabla BELA</span>
          </h3>
          <p className="habla-about-status">
            Speakhabla BELA(Business English Language Assessment) Web App is one
            of my Applied Industry projects. Continuous improvement was sought
            and Megadevs(my team and I ) were able to take it to the next level
            with better facelift(UI/UX Designing) and functionalities(Website
            Development).
            <p />
            <br />
            <p style={{ fontWeight: "bolder", fontSize: "large" }}>
              Our Client :
            </p>
            <p>
              <a
                href="https://speakhabla.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                SPEAKHABLA
              </a>
              , is a language solutions company based in Costa Rica. They help
              business professionals and organizations improve their English
              skills through lessons, classes, and job coaching. For Costa
              Ricans, knowledge of the English language is crucial for anyone
              looking for good paying jobs, and getting accredited certificates
              for their knowledge is the professional standard for many
              employers in the country. <br />
              The growth in virtual delivery during the pandemic and need for
              adaptability to this new development is the major reason
              speakhabla reached out to us to keep up with this new digital
              evolution in order to remain highly competitive in the market.
            </p>
            <br />
            <p style={{ fontWeight: "bolder", fontSize: "large" }}>
              Project Goals :
            </p>
            <p>
              Revitalizing the Speakhabla brand by making it more modern
              including logos and theme.
            </p>
            <p>
              Transforming our client’s current static test into a dynamic test.
            </p>
            <p>
              {" "}
              Having three user interface or dashboards for each of our
              prospective users.
            </p>
            <p>Get instant results, Purchase certificate.</p>
            <p>
              Download the certificate locally as pdf and Share same certificate
              on Linkedin.
            </p>
            <p>Have the Organization manage their team progress.</p>
          </p>
        </div>

        <div className="habla-content">
          <img
            src={speak}
            alt="a pic containing desktop, mouse and speakhabla interface"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-about">
          <h4>User Research</h4>
          <p className="habla-about-status">
            Our design process follows the Enterprise Design Thinking Principles
            and we put heavy emphasis on user feedback. More specifically, I
            collaborated with my team to conduct multiple user research
            interviews that were designed in Spanish. To capture the most
            authentic feedback from our users, our team worked hard to develop
            questions that feel natural to our client's users who are native
            Spanish speakers, and will allow them to fully express their
            feelings in a natural way. The total response we got amounted to
            about 11 and these responses informed our careful decision of coming
            up with our Personas based on our user types which include; A
            Business Professional, Organizations/Corporations, and Speakhabla
            Admin .
          </p>
          <br />
        </div>
        <div className="habla-content">
          <img
            src={sofia}
            alt="Sofia's Persona"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-content">
          <img
            src={personas}
            alt="summary of Personas"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div className="habla-about">
          <h4>Analysis</h4>
          <p className="habla-about-status">
            After the research phase, we analyzed our data and started ideating
            prototypes while taking into account the feedback received. As
            earlier stated, our persona types are:
            <br />
            <br /> 1. Individual User: These are business professionals who wish
            to take an online test in order to assess their English level and
            improve their chances of landing better position in their chosen
            career. They also want to earn a certificate of their English level
            to show their potential employers for better job prospects.
            <br />
            <br />
            2. Organizational Users: These are representatives of organizations
            or companies that have hired SPEAKHABLA for their services (e.g.
            English lessons and job coaching). They wish to track the
            performance and English level of their employees.
            <br />
            <br />
            3. Admin Users: These are SPEAKHABLA's operations team who wish to
            manage their online processes (e.g. modifying their test questions)
            and app users easily.
            <br />
          </p>
          <br />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-about">
          <h4>Information Architecture</h4>
          <p className="habla-about-status">
            From the image displayed on the right, our solution has a lot of
            moving parts. But basically, we divided our functionalities into
            three phases: The phase that we focused on in the past four months
            is Phase 1 (which is in the green) - this represents our core
            functionalities that we thought was most important for the app. Once
            a user gets to our web app, they will be prompted to either register
            or login as an individual user, as an organizational user, or as
            admin user. Depending on the type of user you login as, our app will
            direct the user to their respective dashboards. <br />
            <br />
            Dashboard 1 is our individual user, those business professionals who
            wish to take the main test to assess their English level and to
            purchase their certificate. <br />
            <br />
            Dashboard 2 is our organization user, or managers of a company who
            can see their employees and track the progress of their users in the
            English test. <br />
            <br />
            Dashboard 3 is for our admin user, which for now we are giving them
            the ability to edit the questions on the test (adding, removing, and
            editing).
            <br />
            <br />
            As a disclaimer, we did have to update our information architecture
            and we had to move some of our initial Phase 1 core functionalities
            to Phase 2 due to time constraints such as our Profile Settings page
            for each dashboard and the ability for our admin to manage their
            users - to be able to delete, edit, and add users by themselves via
            our app.
          </p>
          <br />
        </div>
        <div className="habla-content">
          <img
            src={infoarchitecture}
            alt="Information architecture of speakhabla"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-about">
          <h4>Prototype</h4>
          <p className="habla-about-status">
            Individual dashboard allows users or students to take the BELA test,
            assess their English level, and purchase the certificate. Getting an
            English certificate is important in Costa Rica as companies hire
            individuals based on their English skills - and they need some sort
            of proof of your English level. <br />
            The features of this dashboard include Authentication, Dynamic
            testing, Purchase certificate, Download/ share certificate, Display
            test results, Language toggle between english and spanish.
            <br />
            Organizational dashboard - so these are the managers of companies
            who wish to see and track the progress of their employees as they
            take English lessons from Speakhabla. <br /> This dashboard has the
            following features: Authentication,Company code, Overview of users,
            Affiliated users data, Export data, Search function, Filter
            categories.
            <br />
            Finally, the admin dashboard allows our clients to manage the test
            questions of the BELA test using the third party Rowy App, upload
            image/media, carry out authentication and test Overview.
            <br />
            Detailed interactive prototype can be found{" "}
            <a
              href="https://xd.adobe.com/view/e85569bc-359c-46bf-b6fe-a32636fbbe86-bd06/"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </p>
          <br />
        </div>
        <div className="habla-content">
          <img
            src={dashboard}
            alt="Dashboards summary"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-content">
          <img
            src={rebranding}
            alt="displaying old and new interface of speakhabla website"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
        <div className="habla-about">
          <h4>Rebranding</h4>
          <p className="habla-about-status">
            Rebranding took a series of iterative process and continuous
            improvements and I was actively involved. My team and I worked on
            changing the brand and test logo. Their current brand is indicated
            on the left while on the right is our sign in page which
            demonstrates our main visual elements. The geometric designs here
            and the turquoise line creates movement and vibrancy. So there is
            some duality here - our target audience is very diverse as our
            client’s demographic customers ranges from 25 to 55 years old. So we
            needed to ensure it stays professional but also visually interesting
            and appealing.
          </p>
          <br />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-about">
          <h4>Dashboards</h4>
          <p className="habla-about-status">
            Individual dashboard allows users or students to take the BELA test,
            assess their English level, and purchase the certificate. Getting an
            English certificate is important in Costa Rica as companies hire
            individuals based on their English skills - and they need some sort
            of proof of your English level. <br />
            The features of this dashboard include Authentication, Dynamic
            testing, Purchase certificate, Download/ share certificate, Display
            test results, Language toggle between english and spanish. The
            interactive prototype can be found{" "}
            <a
              href="https://xd.adobe.com/view/cb51f3b9-6cd4-4432-9763-87b6868fae0a-9e02/?fullscreen"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            <br />
            <br />
            Organizational dashboard - so these are the managers of companies
            who wish to see and track the progress of their employees as they
            take English lessons from Speakhabla. <br /> This dashboard has the
            following features: Authentication,Company code, Overview of users,
            Affiliated users data, Export data, Search function, Filter
            categories. The interactive prototype can be found{" "}
            <a
              href="https://xd.adobe.com/view/da1e1abe-5834-459f-b1b9-622abfba155f-8f4d/?fullscreen"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            <br />
            <br />
            Finally, the admin dashboard allows our clients to manage the test
            questions of the BELA test using the third party Rowy App, upload
            image/media, carry out authentication and test Overview.The
            interactive prototype can be found{" "}
            <a
              href="https://xd.adobe.com/view/2732618a-1b15-414e-a064-b626428c3fb5-7261/?fullscreen"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
          </p>
          <br />
          <br />
        </div>
        <div className="habla-content">
          <img
            src={dashboard}
            alt="Dashboards summary"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="habla-section">
        <div className="habla-content">
          <img
            src={techStack}
            alt=" displaying tech stack used for speakhabla website"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div className="habla-about">
          <h4>Development Phase / Tech Stack </h4>
          <p className="habla-about-status">
            The technology used to develop this application include:
            <br />
            Programming Language :React, Nodejs and Javascript.
            <br />
            UI Libraries: The material UI and material core UI were used for our
            user interface.
            <br />
            APIs: Linkedin for sharing certificate on social Network, Fygaro, a
            third party payment platform based in costarica, and Rowy a platform
            that helps speakhablea to update their questions
            <br />
            easily and frequently. <br />
            Cloud Infrastructure: Google firebase firestore is the database used
            to save/ collect all our data.
            <br />
            <br />I actively participated in the Frontend development which
            include developing some of the User Interfaces which include Upload
            of media file(tests questions) to generate link that will be pasted
            into Rowy, Conversion for Test questions to JSON, QA Testing, and
            all the parts that involved the certificates(The download as PDF,
            Share on Linkedin Features and all the re-routes involved).
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export default Speakhabla;
